/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export const isSafari = (): boolean => {
  const userAgent = navigator.userAgent;
  return userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1;
};

export function isMobileSafari(): boolean {
  const ua = window.navigator.userAgent;
  const iOS = (ua.match(/iPad/i) || ua.match(/iPhone/i)) !== null;
  const webkit = ua.match(/WebKit/i) !== null;
  return iOS && webkit && !ua.match(/CriOS/i);
}

export function systemModifiedKey(): string {
  const isMac = navigator.platform.startsWith("Mac");
  const modifier = isMac ? "⌘" : "Ctrl";
  return modifier;
}

export function isAndroid(): boolean {
  return navigator.userAgent.indexOf("Android") !== -1;
}

export function isUsingChromeBasedBrowser(): boolean {
  return navigator.userAgent.indexOf("Chrome") !== -1;
}

export function shouldAllowStudioAccessForThisBrowser(): boolean {
  return isUsingChromeBasedBrowser();
}
